import { Container, Grid2, Tab, Tabs } from "@mui/material";
import { useEffect, useRef, useState } from "react";
import { Route, Routes, useLocation, useNavigate, useParams } from "react-router-dom";
import { IFormFieldKeyList } from "../../../_common/models/formFieldKey";
import { IFormTemplateSectionManage } from "../../../_common/models/formTemplateSection";
import { toastr } from "../../../_components/toastr/toastr";
import { formFieldKeyService } from "../../../_services/formFieldKey.service";
import { formTemplateSectionService } from "../../../_services/formTemplateSection.service";
import { FormSectionManage } from "../../form/formSection/formSection-manage";
import { FormFieldKeyList } from "../FormFieldKey/formFieldKey-list";
import { FormFieldKeyManageDrawer } from "../FormFieldKey/formFieldKey-manageDrawer";
import { FormFieldKeyLookupList } from "../formFieldKeyLookup/formFieldKeyLookup-list";
import { FormFieldKeyLookupManage } from "../formFieldKeyLookup/formFieldKeyLookup-manage";
import { FormFieldKeyList2 } from "../FormFieldKey/formFieldKey-list2";

export function FormTemplateSectionView() {
    const editorRef = useRef(null);

    let navigate = useNavigate();
    const location = useLocation();
    const isDrawerOpen = location.pathname.includes('/CreateFormFieldKey') || location.pathname.includes('/EditFormFieldKey/');

    const [data, setData] = useState<IFormTemplateSectionManage>({ formHtml: "" } as IFormTemplateSectionManage);
    const [fieldKeys, setFieldKeys] = useState<Array<IFormFieldKeyList>>([]);
    const [tabValue, setTabValue] = useState(0);

    const [isLoading, setLoading] = useState(false);
    const [count, setCount] = useState(0);
    const [previewRefreshCount, setPreviewRefreshCount] = useState(0);
    const [isDirty, setIsDirty] = useState(false);
    const [areFormFieldKeysLoading, setAreFormFieldKeysLoading] = useState(true);

    const { formTemplateSectionId } = useParams<{ formTemplateSectionId: string }>();
    const _formTemplateSectionId = Number(formTemplateSectionId);
    const tinyMceSettings = {
        height: 500,
        menubar: true,
        plugins: [
            'advlist autolink lists link image charmap print preview anchor',
            'searchreplace visualblocks code table',
            'insertdatetime media '
        ],
        table_appearance_options: true,
        toolbar: 'mybutton ',
        statusbar: true
    };
    const [settings, setSettings] = useState(tinyMceSettings);

    useEffect(() => {
        fetchData();
        fetchFieldKeys();
    }, []);

    useEffect(() => {
        setSettings(tinyMceSettings);
    }, [fieldKeys]);

    function fetchData() {
        setLoading(true);
        return formTemplateSectionService
            .get(+(formTemplateSectionId || 0))
            .then(
                (json) => {
                    setData(json);
                }
            )
            .finally(() => setLoading(false));
    }

    function fetchFieldKeys() {
        setAreFormFieldKeysLoading(true);
        setCount((count + 1))
        return formFieldKeyService
            .getAll(+(formTemplateSectionId || 0))
            .then(
                (json) => {
                    setFieldKeys(json)
                }
            )
            .finally(() => setAreFormFieldKeysLoading(false));
    }

    function submit() {
        setLoading(true);

        let _data = { ...data };
        // _data.formHtml = editorRef.current.getContent();

        return formTemplateSectionService
            .updateForm(_data)
            .then(
                (json) => {
                    toastr.success("Saved Successfully");
                    setIsDirty(false);
                }
            )
            .finally(() => setLoading(false));
    }

    function handleFieldKeySaved() {
        setCount((c) => c + 1);
        setPreviewRefreshCount((c) => c + 1);
    }


    return (
        <>
            <Grid2
                container
                spacing={1}
                sx={{
                    marginRight: isDrawerOpen ? '520px' : 0,
                    transition: 'margin-right 0.3s ease-in-out'
                }}
            >
                <Grid2 size={{ xs: 12 }}>
                    <Tabs value={tabValue} onChange={(e, newValue) => { setTabValue(newValue) }} aria-label="simple tabs example">
                        <Tab label="Form Field Keys" />
                        <Tab label="Preview" />
                    </Tabs>
                </Grid2>
                <Grid2 size={{ xs: 12 }}>
                    {tabValue == 0 &&
                        <FormFieldKeyList2 count={count} editorRef={editorRef} />
                    }
                    {tabValue == 1 &&
                        <>
                            <FormSectionManage
                                formTemplateSectionId={_formTemplateSectionId}
                                isForReview
                                editable
                                isSectionSaving={false}
                                formSectionId={0}
                                externalRefreshCount={previewRefreshCount}
                                onEditFieldClick={(ffk) => {
                                    const keyId = ffk?.id ?? (ffk as { formFieldKeyId?: number })?.formFieldKeyId;
                                    const n = Number(keyId);
                                    if (!Number.isFinite(n) || n <= 0) {
                                        toastr.error("Cannot open this field for editing (missing field id).");
                                        return;
                                    }
                                    navigate(`EditFormFieldKey/${n}`)
                                }}
                                onSave={() => { }} />
                        </>
                    }
                </Grid2>
            </Grid2>

            <Routes>

                {/* Relative paths (no leading /) match under /FormTemplateSections/:formTemplateSectionId/* */}
                <Route path="CreateFormFieldKey" element={<FormFieldKeyManageDrawer emitOnSave={handleFieldKeySaved} emitOnClose={() => { navigate(""); }} />} />

                <Route path="EditFormFieldKey/:formFieldKeyId/*" element={<FormFieldKeyManageDrawer emitOnSave={handleFieldKeySaved} emitOnClose={() => { navigate(""); }} />} >
                    <Route path="CreateFormFieldKeyLookup" element={<FormFieldKeyLookupManage emitOnSave={handleFieldKeySaved} emitOnDelete={() => { }} />} />
                    <Route path="EditFormFieldKeyLookup/:formFieldKeyLookupId" element={<FormFieldKeyLookupManage emitOnSave={handleFieldKeySaved} emitOnDelete={() => { }} />} />
                    <Route index element={<FormFieldKeyLookupList />} />
                </Route>

            </Routes>
        </>
    );
}